import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.7 15.7"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12.9 7.9h-2v-2h2zm0 4.9h-2v-2h2zm-4-4.9h-2v-2h2zm-4 3h-2v2h2zm4 0h-2v2h2zm5-9.1V0h-3v1.8h-6V0h-3v1.8H0v13.9h15.7V1.8zm-2-1h1v2h-1zm-9 .1h1v2h-1zm12 14H.9v-11h14z" />
  </svg>
);
const SvgCalendar = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="calendar" {...props} />;
export default SvgCalendar;
